import { TermsContent } from '../../components/legal/TermsContent';
import { LegalPage } from './LegalPage';

export function TermsPage() {
  return <LegalPage doc="terms">{(lang) => <TermsContent lang={lang} />}</LegalPage>;
}

export default TermsPage;
